import { render, staticRenderFns } from "./CartBoxItem.vue?vue&type=template&id=5898aec0&scoped=true&"
import script from "./CartBoxItem.vue?vue&type=script&lang=js&"
export * from "./CartBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./CartBoxItem.vue?vue&type=style&index=0&id=5898aec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5898aec0",
  null
  
)

export default component.exports